export default __webpack_public_path__ + "static/media/collapse.8ae61e7c.svg";